export class BrowserUtils {
    public static openUrlInNewTab = (url: string) => window.open(url, '_blank');
}